const swiperComponent = class extends HTMLElement {
    swiper = this.querySelector('.swiper-container');

    connectedCallback() {
        this._initSwiper();
        $(document).on('quick-buy-popover:change:end', e => this._initSwiper(e));
    }

    _initSwiper(e) {
        const swiperScrollbar = this.querySelector('.swiper-scrollbar');
        const isDesktop = window.innerWidth >= 1024;

        const swiper = new Swiper(this.swiper, {
            slidesPerView: this.swiper.getAttribute('slides-per-view') || 1,
            loop: true,
            initialSlide: isDesktop ? 1 : 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            scrollbar: {
                el: swiperScrollbar || null,
                draggable: true,
            },
        });

    }
};

window.customElements.define('swiper-component', swiperComponent);
